import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Box } from "@material-ui/core"
import { RowBox } from "../Boxes"

const useStyles = makeStyles((theme) => ({
  master: {
    padding: theme.spacing(2),
    margin: 0,
    borderRadius: 3,
    backgroundColor: ({ color }) =>
      color === "warning" ? theme.palette.warning.background : theme.palette.primary.shaded.background,
  },
  title: {
    fontSize: 16,
    color: ({ color }) => (color === "warning" ? theme.palette.warning.main : theme.palette.primary.main),
  },
  body: {
    paddingBottom: theme.spacing(0.5),
  },
}))

const Blockquote = ({ icon, title, body, pb = 1, color = "primary", cy = "Blockquote" }) => {
  const classes = useStyles({ color })

  return (
    <blockquote className={classes.master} data-cy={cy}>
      {title && (
        <RowBox className={classes.title} mb={pb}>
          {icon && <>{icon}</>}
          <Box ml={icon ? 1 : 0}>{title}</Box>
        </RowBox>
      )}
      {body && <div className={classes.body}>{body}</div>}
    </blockquote>
  )
}

export { Blockquote }
